var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 71,
    viewBox: "0 0 74 71"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m1.3 25.9 35-24.6 35.9 24.8-18.8 27.5-33.4-1-8.6-3.6-5.5-12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "m53.4 54.6-33.4-1h-.4L11 49.9a1 1 0 0 1-.5-.5L5 37.2.3 26.3a1 1 0 0 1 .3-1.2L35.6.5a1 1 0 0 1 1.1 0l36 24.8a1 1 0 0 1 .3 1.4L54.2 54.2a1 1 0 0 1-.8.4m-33.2-3 32.6 1 18-26.2L36.3 2.5 2.5 26.2l4.3 10.1 5.3 11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.2 10.2h57v40.81h-57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c34cd",
    d: "M66.2 52h-57a1 1 0 0 1-1-1V10.2a1 1 0 0 1 1-1h57a1 1 0 0 1 1 1V51a1 1 0 0 1-1 1m-56-2h55V11.2h-55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDEAEF",
    d: "M56.1 21.8H20.6a1 1 0 0 1 0-2h35.5a1 1 0 0 1 0 2m0 7.5H20.6a1 1 0 0 1 0-2h35.5a1 1 0 0 1 0 2m-11.7 7.5H20.6a1 1 0 0 1 0-2h23.8a1 1 0 0 1 0 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1.1 64.9V26.4l25.8 21.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M1.1 65.9a1 1 0 0 1-1-1V26.4a1 1 0 0 1 1.6-.8l25.9 21.6a1 1 0 1 1-1.3 1.5L2.1 28.5v36.4a1 1 0 0 1-1 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M72.3 64.9V26.4L46.5 47.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M72.3 65.9a1 1 0 0 1-1-1V28.5L47.1 48.7a1 1 0 0 1-1.3-1.5l25.9-21.6a1 1 0 0 1 1.6.8v38.5a1 1 0 0 1-1 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M68.8 69.7H4.6a3.5 3.5 0 0 1-3.5-3.5v-1.3l33.8-22.8a3.5 3.5 0 0 1 3.9 0l33.5 22.8v1.3a3.5 3.5 0 0 1-3.5 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M68.8 70.7H4.6a4.5 4.5 0 0 1-4.5-4.5v-1.3a1 1 0 0 1 .4-.9l33.8-22.8a4.5 4.5 0 0 1 5 0L72.9 64a1 1 0 0 1 .4.8v1.3a4.5 4.5 0 0 1-4.5 4.6M2.1 65.4v.8a2.5 2.5 0 0 0 2.5 2.5h64.2a2.5 2.5 0 0 0 2.5-2.5v-.8L38.2 42.9a2.5 2.5 0 0 0-2.8 0z"
  }))));
};
export default SvgEnvelope;